import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { DocumentoSeleccionado } from '@/types/getPendingPaymentsType';

type GetTripsResponse = {
  state: number;
  value: DocumentoSeleccionado[];
};

type QueryType = {
  retencionTitular: boolean;
  vencimiento: Date | null;
  codigo: string;
};

export const getAccountStatement = async (
  query: QueryType
): Promise<DocumentoSeleccionado[]> => {
  try {
    const res = await apiClient.post<GetTripsResponse>(
      Endpoints.AccountStatement,
      { ...query }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
